export const getBotColor = (baseAsset: string) => {
  switch (baseAsset) {
    case 'BTC':
      return '#E6973E';

    case 'XRP':
      return '#222222';

    case 'VET':
      return '#55BDF9';

    case 'ADA':
      return '#67C5C7';

    case 'DOT':
      return '#D23078';

    case 'GALA':
      return '#C0C0C0';

    case 'LUNA':
      return '#2D47A7';

    case 'SAND':
      return '#4CACE9';

    case 'SOL':
      return '#67CBBA';

    case 'LINK':
      return '#335DD2';

    case 'PYR':
      return '#EBA043';

    case 'RUNE':
      return '#62D7E0';

    case 'KDA':
      return '#D9348D';

    case 'ILV':
      return '#140C33';

    case 'ETH':
      return '#6680E3';

    case 'BNB':
      return '#EBBB4E';

    case 'AR':
      return '#232323';

    case 'FTT':
      return '#48A3BE';

    case 'OP':
      return '#D02C1F';

    case 'MATIC':
      return '#7850DF';

    case 'APE':
      return '#1745B9';

    case 'QNT':
      return '#232323';

    case 'FET':
      return '#202842';

    case 'GMX':
      return '#3D6CEC';

    case 'WOO':
      return '#111924';

    case 'CTXC':
      return '#46A2D2';

    case 'AGIX':
      return '#1B1048';

    case 'RAY':
      return '#711ef7';

    case 'SUI':
      return '#4594fb';

    case 'ONDO':
      return '#373a49';

    case 'PEPE':
      return '#3c8d3d';

    case 'TRUMP':
      return '#bd9a58';

    case 'HBAR':
      return '#303030';

    case 'BEAMX':
    case 'BEAM':
      return '#f4ce4e';

    case 'RENDER':
      return '#c80713';

    case 'DOGE':
      return '#c59734';

    case 'TAO':
      return '#fcfcfc';

    case 'NMT':
      return '#fc8f21';

    case 'FARTCOIN':
      return '#b9d0da';

    case 'JUP':
      return '#5cd9b3';

    case 'AIXBT':
      return '#a467ea';

    case 'VVV':
      return '#09283e';

    case 'GPU':
      return '#45ba5a';

    case 'DSYNC':
      return '#7c221c';

    case 'AVAX':
      return '#d65049';

    case 'SUPER':
      return '#91eb9c';

    case 'TON':
      return '#4396e3';

    case 'PENGU':
      return '#94b2f8';

    case 'HYPE':
      return '#aff9e5';

    case 'GRASS':
      return '#bcf44d';

    case 'GIGA':
      return '#939393';

    case 'ENA':
      return '#272727';

    default:
      return '';
  }
};
